export const WEBCAM_QUALITIES = [
  {
    label: 'Auto',
    value: 'auto',
  },
  {
    label: '1920x1080 (Full HD)',
    value: '1920x1080',
  },
  {
    label: '1280x720 (High Definition)',
    value: '1280x720',
  },
  {
    label: '800x600 (Standard Definition)',
    value: '800x600',
  },
  {
    label: '640x480 (Normal Definition)',
    value: '640x480',
  },
  {
    label: '640x360 (Lightweight)',
    value: '640x360',
  },
]

export const WEBCAM_QUALITY_AUTO = WEBCAM_QUALITIES[0].value
